// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_5862s","alignToEdge":"P1Mif","buttonIcon":"tjszz","buttonCaption":"zSSI9","buttonSpacer":"HV709"};